import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { getPageData, getPreviewPageData, getPreviewTheme, getTheme } from 'src/services/customisation'
import { NextPageContext } from 'next'
import type { MetaStateInReducer } from '../meta'

export const fetchTheme = createAsyncThunk(
  '@customisations/theme',
  async (
    params: { isServer: boolean; req: NextPageContext['req'] },
    thunkApi
  ) => {
    const state = thunkApi.getState() as MetaStateInReducer
    const menuId = state['@meta'].detailMenuSite.data.menu.id
    const result = await getTheme({
      siteId: menuId,
      isServer: params.isServer
    })
    return result.data
  }
)

export const fetchPageData = createAsyncThunk(
  '@customisations/pageData',
  async (
    params: {
      pageName: string
      slug: string
      isServer: boolean
    },
    thunkApi
  ) => {
    const { pageName, isServer } = params
    const state = thunkApi.getState() as MetaStateInReducer
    const menuId = state['@meta'].detailMenuSite.data.menu.id

    const result = await getPageData({
      slug: params.slug,
      isServer,
      pageName,
      siteId: menuId
    })

    return result.data
  }
)

export const fetchThemePreview = createAsyncThunk(
  '@customisations/themePreview',
  async (
    params: {
      previewToken: string
      isServer: boolean
      req: NextPageContext['req']
    },
    thunkApi
  ) => {
    const state = thunkApi.getState() as MetaStateInReducer
    const menuId = state['@meta'].detailMenuSite.data.menu.id

    const result = await getPreviewTheme({
      menuId,
      isServer: params.isServer,
      previewToken: params.previewToken
    })
    return result.data
  }
)

export const fetchPreviewPageData = createAsyncThunk(
  '@customisations/previewPageData',
  async (
    params: {
      pageName: string
      slug: string
      isServer: boolean
    },
    thunkApi
  ) => {
    const { pageName, isServer } = params
    const state = thunkApi.getState() as MetaStateInReducer

    const menuId = state['@meta'].detailMenuSite.data.menu.id

    const result = await getPreviewPageData({
      slug: params.slug,
      isServer,
      pageName,
      siteId: menuId
    })
    return result.data
  }
)

export const updateCustomisationSetting = createAction(
  '@customisations/updateCustomisationSetting',
  ({
    themeSettingData,
    sectionSettingData,
    sortingSectionOrder,
    sortingSectionId,
    currentAction
  }: {
    themeSettingData: Customisation.ThemeSettingData
    sectionSettingData: Customisation.SectionSettingData
    sortingSectionOrder: string[]
    sortingSectionId: string
    currentAction: Record<string, unknown>
  }) => {
    return {
      payload: {
        themeSettingData,
        sectionSettingData,
        sortingSectionOrder,
        sortingSectionId,
        currentAction
      }
    }
  }
)

export const setThemeCache = createAction(
  '@meta/setThemeCache',
  (params) => {
    return {
      payload: params
    }
  }
)

export const setPageDataCache = createAction(
  '@meta/setPageDataCache',
  (params) => {
    return {
      payload: params
    }
  }
)
